"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTreeNodeData = void 0;
var GlobalUtils_1 = __importDefault(require("../../../../../shared/util/GlobalUtils"));
var AbstractTreeNodeData = /** @class */ (function () {
    // #endregion Properties (3)
    // #region Constructors (1)
    /**
     * Creates a tree node data object.
     *
     * @param id Id of this data object
     */
    function AbstractTreeNodeData(id) {
        this._id = id || GlobalUtils_1.default.createRandomId();
        this._version = GlobalUtils_1.default.createRandomId();
    }
    Object.defineProperty(AbstractTreeNodeData.prototype, "id", {
        // #endregion Constructors (1)
        // #region Public Accessors (2)
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractTreeNodeData.prototype, "version", {
        get: function () {
            return this._version;
        },
        enumerable: false,
        configurable: true
    });
    // #endregion Public Accessors (2)
    // #region Public Methods (1)
    /**
     * Update the version
     */
    AbstractTreeNodeData.prototype.updateVersion = function () {
        this._version = GlobalUtils_1.default.createRandomId();
    };
    return AbstractTreeNodeData;
}());
exports.AbstractTreeNodeData = AbstractTreeNodeData;
